(function () {
    'use strict';

    function splitToWords() {
        return function (value) {
            var output, i, l, capRe = /[A-Z]/;
            if (typeof (value) !== "string") {
                throw new Error("The \"word\" parameter must be a string.");
            }
            output = [];
            for (i = 0, l = value.length; i < l; i += 1) {
                if (i === 0) {
                    output.push(value[i].toUpperCase());
                }
                else {
                    if (i > 0 && capRe.test(value[i])) {
                        output.push(" ");
                    }
                    output.push(value[i]);
                }
            }
            return output.join("");
        };
    }

    angular.module('ecap.common').filter('splitToWords', splitToWords);
})();